import { toast } from 'react-toastify';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import BeatLoader from 'react-spinners/BeatLoader';
import { Button, TextField, InputAdornment } from '@material-ui/core';
import Swal from 'sweetalert2'

import Prompt from './Prompt/Prompt';
import PromptWrapper from './Prompt/Wrapper';
import PromptActions from './Prompt/Actions';

import { useAppContext } from '../../Context/App/Provider';
import { activateContactEmail, setContactEmail } from '../../Functions/user';
import { decodeHTMLEntities } from '../../Functions/utils';

import { toastTimerValue } from '../../Shared/utils';

import '../SweetAlert.css'


export default function ContactEmail({setEmailPrompt}) {
  const { t } = useTranslation();
  const [{user}, appDispatch] = useAppContext();

  const [code, setCode] = useState(null);
  const [email, setEmail] = useState(null);
  const [loading, setLoading] = useState(false);


  const handleSetEmail = async (email = null) => {
    setLoading(true);
    const res = await setContactEmail(user.id, email, localStorage.getItem('lang'));

    // console.log("28 - res=", res);
    setLoading(false);

    if (!res.success) {
      toast(decodeHTMLEntities(t('email.errors.' + res)), {type: 'error'});      
      // Swal.fire({
      //   toast: true,
      //   icon: 'error',
      //   title: t('scenarios.errors.no_name'),
      //   animation: true,
      //   position: 'top-right',
      //   showConfirmButton: false,
      //   timer: toastTimerValue,
      //   timerProgressBar: true,
      //   iconColor: 'white',
      //   customClass: {
      //     popup: 'colored-toast',
      //   },
      //   didOpen: (toast) => {
      //     toast.addEventListener('mouseenter', Swal.stopTimer)
      //     toast.addEventListener('mouseleave', Swal.resumeTimer)
      //     toast.addEventListener('click', Swal.close)
      //   }
      // });
      return { success: false };
    }

    appDispatch({
      user: {
      ...user,
      contactEmail: res.user.contactEmail,
      contactEmailCode: res.user.contactEmailCode,
      contactEmailActivated: res.user.contactEmailActivated
      }
    });

    return { success: true };
  };

  const handleActivateEmail = async () => {
    setLoading(true);
    const res = await activateContactEmail(user.id, user.contactEmail, code);
    setLoading(false);

    if (!res.success) {
      return toast(decodeHTMLEntities(t('email.errors.' + res)), { type: 'error' });

      // return Swal.fire({
      //   toast: true,
      //   icon: 'error',
      //   title: t('email.errors.' + res),
      //   animation: true,
      //   position: 'top-right',
      //   showConfirmButton: false,
      //   timer: toastTimerValue,
      //   timerProgressBar: true,
      //   iconColor: 'white',
      //   customClass: {
      //     popup: 'colored-toast',
      //   },
      //   didOpen: (toast) => {
      //     toast.addEventListener('mouseenter', Swal.stopTimer)
      //     toast.addEventListener('mouseleave', Swal.resumeTimer)
      //     toast.addEventListener('click', Swal.close)
      //   }
      // });
    }

    setEmailPrompt(false);
    toast(decodeHTMLEntities(t('email.success')), { type: 'success' });

    // Swal.fire({
    //   toast: true,
    //   icon: 'success',
    //   title: t('email.success'),
    //   animation: true,
    //   position: 'top-right',
    //   showConfirmButton: false,
    //   timer: toastTimerValue,
    //   timerProgressBar: true,
    //   iconColor: 'white',
    //   customClass: {
    //     popup: 'colored-toast',
    //   },
    //   didOpen: (toast) => {
    //     toast.addEventListener('mouseenter', Swal.stopTimer)
    //     toast.addEventListener('mouseleave', Swal.resumeTimer)
    //     toast.addEventListener('click', Swal.close)
    //   }
    // });

    appDispatch({
      user: {
      ...user,
      contactEmail: res.user.contactEmail,
      contactEmailCode: res.user.contactEmailCode,
      contactEmailActivated: res.user.contactEmailActivated
      }
    });
  };

  const handleCancelEmail = async (resetDb = true) => {
    if (resetDb) await handleSetEmail();

    setEmail(null);
    setEmailPrompt(false);
    sessionStorage.setItem('emailPrompted', true);
  };


  useEffect(() => {
    // Add Enter key functionality without using <form> (which causes issues here)
    const sendForm = (e) => {
      if (e.key === 'Enter') document.getElementById(user.contactEmail ? 'activate' : 'set').click();
    };

    window.addEventListener('keypress', sendForm);

    return () => window.removeEventListener('keypress', sendForm);
  }, [user]);


  return user.contactEmail ? (

    <Prompt animated>
      <div className="prompt__container animated" style={{ height: '60%' }}>
        <PromptWrapper>
          <div className="prompt__title">
            <h1>{t('email.activate.title')}</h1>
            <p>{t('email.activate.subtitle')}</p>
          </div>

          <div className="prompt__content">
            <div style={{display: 'flex'}}>
              <TextField
                InputProps={{
                  startAdornment: <InputAdornment position="start">
                    <span className="material-icons-outlined">lock</span>
                  </InputAdornment>,
                  type: "password"
                }}
                variant="outlined"
                value={code ?? ''}
                label={t('email.activate.field')}
                onChange={e => setCode(e.target.value)}
                style={{flexGrow: 1, marginRight: '15px'}}
              />

              <Button disabled={!code || loading} id="activate" onClick={handleActivateEmail}>
                {loading ? (
                  <BeatLoader color="white" css="transform:translateY(3px)scale(0.8)"/>
                ) : (
                  <span
                    className="material-icons-round"
                    style={{padding: '0 15px 0 14px', fontSize: '28px', color: 'white'}}
                  >
                    send
                  </span>
                )}
              </Button>
            </div>
          </div>
        </PromptWrapper>

        <PromptActions column>
          <Button
            className="btnSecondary"
            onClick={() => appDispatch({user: {...user, contactEmail: null}})}
          >{t('email.activate.wrong_email')}</Button>

          <Button
            className="btnDismiss"
            onClick={() => handleCancelEmail()}
            // there should be no parameters passed to the function
          >{t('email.activate.remind')}</Button>
        </PromptActions>
      </div>
    </Prompt>

  ) : (

    <Prompt animated>
      <div className="prompt__container animated" style={{ height: '60%' }}>
        <PromptWrapper>
          <div className="prompt__title">
            <h1>{t('email.set.title')}</h1>
            <p>{t('email.set.subtitle')}</p>
          </div>

          <div className="prompt__content">
            <TextField
              InputProps={{
                startAdornment: <InputAdornment position="start">
                  <span className="material-icons-outlined">email</span>
                </InputAdornment>
              }}
              variant="outlined"
              value={email ?? ''}
              label={t('email.set.field')}
              onChange={e => setEmail(e.target.value)}
            />
          </div>
        </PromptWrapper>

        <PromptActions column>
          <Button
            className="btnPrimary" id="set" onClick={() => handleSetEmail(email)}
            disabled={loading || !(''+email).match(/^\w+([.-]\w+)*@\w+([.-]\w+)*(\.\w{2,})+$/)}
          >
            {loading ? <BeatLoader color="white" css="transform:translateY(3px)"/> : t('email.set.send_email')}
          </Button>

          <Button
            className="btnDismiss"
            onClick={() => handleCancelEmail(!user.contactEmailActivated && user.contactEmailCode)}
          >
            {t('email.set.remind')}
          </Button>
        </PromptActions>
      </div>
    </Prompt>
    
  );
}
